import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=1633cec8&scoped=true"
import script from "./Attach.vue?vue&type=script&lang=js"
export * from "./Attach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633cec8",
  null
  
)

export default component.exports